<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <div>
      <v-row align="center" justify="center">
        <v-col cols="8">
          <v-text-field label="Όνομα" v-model="firstName" readonly>
          </v-text-field>
        </v-col>
        <v-col cols="8">
          <v-text-field label="Επώνυμο" v-model="lastName" readonly>
          </v-text-field>
        </v-col>

        <v-col cols="8">
          <v-text-field label="Email" v-model="email" readonly> </v-text-field>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      firstName: (state) => state.auth.firstName,
      lastName: (state) => state.auth.lastName,
      email: (state) => state.auth.email,
    }),
  },
};
</script>

<style scoped lang="scss">
</style>